import { CoordinatesModel } from '../interfaces';

export interface KnownCity {
  readonly name: string;
  readonly coordinates: CoordinatesModel;
}

export const knownCitiesConst: readonly KnownCity[] = [
  { name: 'Warszawa', coordinates: { latitude: 52.23, longitude: 21.012 } },
  { name: 'Kraków', coordinates: { latitude: 50.061, longitude: 19.937 } },
  { name: 'Wrocław', coordinates: { latitude: 51.1, longitude: 17.033 } },
  { name: 'Łódź', coordinates: { latitude: 51.771, longitude: 19.474 } },
  { name: 'Poznań', coordinates: { latitude: 52.407, longitude: 16.93 } },
  { name: 'Gdańsk', coordinates: { latitude: 54.352, longitude: 18.649 } },
  { name: 'Szczecin', coordinates: { latitude: 53.429, longitude: 14.553 } },
  { name: 'Lublin', coordinates: { latitude: 51.25, longitude: 22.567 } },
  { name: 'Bydgoszcz', coordinates: { latitude: 53.123, longitude: 18.008 } },
  { name: 'Białystok', coordinates: { latitude: 53.133, longitude: 23.164 } },
  { name: 'Katowice', coordinates: { latitude: 50.258, longitude: 19.028 } },
  { name: 'Gdynia', coordinates: { latitude: 54.519, longitude: 18.532 } },
  { name: 'Częstochowa', coordinates: { latitude: 50.796, longitude: 19.124 } },
  { name: 'Rzeszów', coordinates: { latitude: 50.0413, longitude: 21.999 } },
  { name: 'Radom', coordinates: { latitude: 51.4036, longitude: 21.1567 } },
  { name: 'Toruń', coordinates: { latitude: 53.0222, longitude: 18.6111 } },
  { name: 'Sosnowiec', coordinates: { latitude: 50.2863, longitude: 19.1041 } },
  { name: 'Kielce', coordinates: { latitude: 50.8742, longitude: 20.6333 } },
  { name: 'Gliwice', coordinates: { latitude: 50.294, longitude: 18.667 } },
  { name: 'Olsztyn', coordinates: { latitude: 53.7778, longitude: 20.4792 } }
];
